module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion_m_jp.a4790c080c44052600e42d1543c87e53.png";